import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';

// Components 

import Box from '@mui/material/Box';
import Button from '../inputs/Button';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { setNotificationMessage } from '../../../redux/features/general/notification';
import { setDashboardSection, setIsSuscribedPopupOpened } from '../../../redux/features/general/navigation';
import CancelButton from '../inputs/CancelButton';


interface Props { 

}; 

const SuscribedPopup: React.FC<Props> = ({ }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 
    const isMobile = useMediaQuery('(max-width: 768px)');

    const colors = useAppSelector(state => state.theme.colors); 

    // --
    // -- 

    const handleQuit = () => { 

        dispatch(setDashboardSection('billing')); 

        navigate('/group'); 

        dispatch(setIsSuscribedPopupOpened(false)); 

    }; 
    
    // -- 

    return (

        <Box 
            onClick={handleQuit}
            sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'center', 
                justifyContent: 'center',
                width: '100vw',
                height: '100vh', 
                backgroundColor: colors?.popup, 
                overflow: 'hidden', 
                position: 'absolute', 
                zIndex: 100000000,
        }}>

            <Box
                onClick={(e) => e.stopPropagation()}
                sx={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    alignItems: 'center', 
                    justifyContent: 'space-evenly',
                    textAlign: 'center', 
                    maxWidth: isMobile ? '90vw' : '450px',
                    width: '100%',
                    padding: isMobile ? 2 : 3, 
                    borderRadius: 5,
                    fontSize: 14,
                    backgroundColor: colors?.container,
                }}
            >

                <Box
                    component="img"
                    sx={{
                        width: 100,
                        marginTop: 3, 
                        marginBottom: 2, 
                    }}
                    src={require('../../../assets/icons/consultation/patientConsent.png')}
                />

                <Box
                    sx={{ 
                        width: '90%',
                        marginBottom: 1 
                    }}
                >{t('thanksForSubscribing')}

                </Box>

                <Button 
                    title={'continue'}
                    triggerFunction={handleQuit}
                    extraStyle={{ width: isMobile ? '80%' : 200, marginBottom: 4, marginTop: 2 }}
                />

            </Box>

            <CancelButton handler={handleQuit} extraStyle={{ fontSize: 30 }} />

        </Box>

  );

};

export default SuscribedPopup;